import { createAsyncThunk } from "@reduxjs/toolkit";
import { postLoginService } from "../../Services";

export const fetchConfigurations = createAsyncThunk(
    "configuration/fetchConfigurations",
    async (_, thunkAPI) => {
        try {
            const url = `/api/configurations/Configurations`;
            const res = await postLoginService.get(url);
            const cfg =
                res.data?.Result?.config ??
                res.data?.data?.Result?.config ??
                {};

            return cfg;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Failed to load configuration"
            );
        }
    }
);


export default fetchConfigurations;
